module.exports = __webpack_public_path__ + "img/thumbnail-rocky.3e8d1708.jpg";